/* ChinChin 2.0 — storefront behaviours (no dependencies) */
(function () {
  'use strict';

  const money = (cents) => {
    const n = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + n;
  };

  const getCartDrawer = () => document.querySelector('cart-drawer');

  const toast = (msg) => {
    let el = document.querySelector('.cc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cc-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3200);
  };

  const fetchJSON = (url, opts) =>
    fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then((r) => r.json());

  const sectionsToRender = () => {
    const cart = getCartDrawer();
    return cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : [];
  };

  const openDrawerWith = (response) => {
    const cart = getCartDrawer();
    if (!cart) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    cart.classList.remove('is-empty');
    const inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    if (response && response.sections) {
      cart.renderContents(response);
    } else {
      fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((r) => r.json())
        .then((sections) => cart.renderContents({ sections }));
    }
    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'chinchin', cartData: response });
    }
  };

  const addItems = (items) =>
    fetchJSON(window.routes.cart_add_url, {
      method: 'POST',
      body: JSON.stringify({ items, sections: sectionsToRender(), sections_url: window.location.pathname }),
    });

  /* Announcement rotator */
  document.querySelectorAll('[data-cc-announce]').forEach((bar) => {
    const items = bar.querySelectorAll('.cc-announce__item');
    if (items.length < 2) return;
    let i = 0;
    const interval = parseInt(bar.dataset.interval, 10) || 4500;
    let timer;
    const show = (n) => {
      items[i].classList.remove('is-active');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active');
    };
    const start = () => (timer = setInterval(() => show(i + 1), interval));
    const restart = () => { clearInterval(timer); start(); };
    bar.querySelector('.cc-announce__arrow--prev')?.addEventListener('click', () => { show(i - 1); restart(); });
    bar.querySelector('.cc-announce__arrow--next')?.addEventListener('click', () => { show(i + 1); restart(); });
    start();
  });

  /* Quick add buttons (cards, upsells, bundles) — event delegation survives drawer re-renders */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    const raw = (btn.dataset.ccAdd || '').trim();
    let items;
    if (/^\d+$/.test(raw)) {
      items = [{ id: parseInt(raw, 10), quantity: 1 }];
    } else {
      try {
        items = JSON.parse(raw);
      } catch (err) {
        items = [];
      }
    }
    if (!Array.isArray(items)) items = [items];
    items = items
      .map((it) => (typeof it === 'number' || typeof it === 'string' ? { id: parseInt(it, 10), quantity: 1 } : it))
      .filter((it) => it && it.id);
    if (!items.length) {
      toast('No se pudo agregar al carrito.');
      return;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    addItems(items)
      .then((res) => {
        if (res.status || res.errors) {
          toast(res.description || res.message || (typeof res.errors === 'string' ? res.errors : 'No se pudo agregar al carrito.'));
          return;
        }
        openDrawerWith(res);
      })
      .catch(() => toast('No se pudo agregar al carrito. Intenta de nuevo.'))
      .finally(() => {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  });

  /* Gift with purchase + countdown (per product, persists across reloads) */
  const giftEl = document.querySelector('[data-cc-gift]');
  const gift = {
    active: () => false,
    variant: 0,
  };
  if (giftEl) {
    const key = giftEl.dataset.key || 'cc_gift';
    const minutes = parseInt(giftEl.dataset.minutes, 10) || 30;
    const revive = parseInt(giftEl.dataset.revive, 10) || 15;
    gift.variant = parseInt(giftEl.dataset.variant, 10) || 0;
    const timers = () => document.querySelectorAll('[data-cc-gift-timer]');
    const stickyBar = document.querySelector('[data-cc-sticky]');
    let end = 0;
    const store = (v) => { try { localStorage.setItem(key, String(v)); } catch (e) {} };
    const load = () => { try { return parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { return 0; } };
    const setEnd = (ms) => { end = Date.now() + ms; store(end); render(); };
    const render = () => {
      const left = Math.max(0, end - Date.now());
      const expired = left <= 0;
      const m = Math.floor(left / 60000);
      const sec = Math.floor((left % 60000) / 1000);
      const txt = `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
      timers().forEach((t) => (t.textContent = txt));
      giftEl.classList.toggle('is-expired', expired);
      document.querySelectorAll('[data-cc-exit]').forEach((x) => x.classList.toggle('is-gift-expired', expired));
      if (stickyBar) stickyBar.classList.toggle('is-gift-expired', expired);
    };
    end = load();
    if (!end) setEnd(minutes * 60000);
    gift.active = () => gift.variant > 0 && end - Date.now() > 0;
    render();
    setInterval(render, 1000);
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-cc-gift-revive]')) return;
      setEnd(revive * 60000);
      toast(`Listo: tu regalo está activo ${revive} minutos más.`);
    });
  }

  /* Product form with add-ons + file upload */
  class CCProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.submitBtn = this.querySelector('[data-cc-submit]');
      this.error = this.querySelector('.cc-form__error');
      this.basePrice = parseInt(this.dataset.price, 10) || 0;
      this.qtyInput = this.form.querySelector('input[name="quantity"]');
      this.totalEl = this.querySelector('[data-cc-total]');
      this.stickyTotal = document.querySelector('[data-cc-sticky-price]');
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.addEventListener('change', () => this.updateTotal());
      this.querySelectorAll('[data-cc-qty]').forEach((b) =>
        b.addEventListener('click', () => {
          const v = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + parseInt(b.dataset.ccQty, 10));
          this.qtyInput.value = v;
          this.updateTotal();
        })
      );
      this.updateTotal();
    }

    selectedAddons() {
      return [...this.querySelectorAll('input[data-cc-addon]:checked')].map((i) => ({
        id: parseInt(i.value, 10),
        quantity: 1,
        price: parseInt(i.dataset.price, 10) || 0,
      }));
    }

    updateTotal() {
      const qty = parseInt(this.qtyInput?.value, 10) || 1;
      const addons = this.selectedAddons();
      const total = this.basePrice * qty + addons.reduce((s, a) => s + a.price, 0);
      if (this.totalEl) {
        this.totalEl.innerHTML = addons.length
          ? `Total con adicionales: <strong>${money(total)}</strong>`
          : '';
      }
      if (this.submitBtn) {
        const label = this.submitBtn.querySelector('[data-cc-label]');
        if (label) label.textContent = `${this.submitBtn.dataset.label} · ${money(total)}`;
      }
      if (this.stickyTotal) this.stickyTotal.textContent = money(total);
    }

    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg;
      this.error.classList.toggle('is-visible', !!msg);
    }

    onSubmit(e) {
      e.preventDefault();
      if (this.submitBtn.classList.contains('is-loading')) return;
      this.showError('');
      const required = this.form.querySelector('input[type="file"][required]');
      if (required && !required.files.length) {
        this.showError('Sube la foto que quieres pintar para continuar.');
        required.focus();
        return;
      }
      this.submitBtn.classList.add('is-loading');
      this.submitBtn.setAttribute('aria-disabled', 'true');
      const fd = new FormData(this.form);
      const extras = this.selectedAddons().map((a) => ({ id: a.id, quantity: a.quantity }));
      if (gift.active()) extras.push({ id: gift.variant, quantity: 1 });
      const sections = sectionsToRender();
      if (!extras.length) {
        fd.append('sections', sections.join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status || res.errors) {
            this.showError(res.description || res.message || (typeof res.errors === 'string' ? res.errors : 'No se pudo agregar al carrito.'));
            return null;
          }
          if (extras.length) return addItems(extras);
          return res;
        })
        .then((res) => {
          if (!res) return;
          if (res.status || res.errors) {
            this.showError(res.description || 'Se agregó el kit, pero un adicional no está disponible.');
            openDrawerWith(null);
            return;
          }
          try { sessionStorage.setItem('cc_added', '1'); } catch (err) {}
          openDrawerWith(res);
        })
        .catch(() => this.showError('Ocurrió un error. Intenta de nuevo.'))
        .finally(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-disabled');
        });
    }
  }
  if (!customElements.get('cc-product-form')) customElements.define('cc-product-form', CCProductForm);

  /* Sticky add-to-cart bar on mobile */
  const sticky = document.querySelector('[data-cc-sticky]');
  const anchor = document.querySelector('[data-cc-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const mainBtn = document.querySelector('cc-product-form [data-cc-submit]') || anchor;
    sticky.classList.add('is-visible');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => sticky.classList.toggle('is-visible', !en.isIntersecting));
      },
      { threshold: 0.6 }
    );
    io.observe(mainBtn);
    sticky.querySelector('[data-cc-sticky-btn]')?.addEventListener('click', () => {
      const form = document.querySelector('cc-product-form form');
      if (form) form.requestSubmit();
    });
  }

  /* Exit-intent on mobile: fast scroll-up after reading, or idle. Once per session. */
  const exitEl = document.querySelector('[data-cc-exit]');
  if (exitEl) {
    const key = exitEl.dataset.key || 'cc_exit';
    const idleMs = (parseInt(exitEl.dataset.idle, 10) || 60) * 1000;
    const seen = () => { try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; } };
    const addedToCart = () => { try { return sessionStorage.getItem('cc_added') === '1'; } catch (e) { return false; } };
    const drawerOpen = () => { const c = getCartDrawer(); return c && c.classList.contains('active'); };
    const show = () => {
      if (seen() || addedToCart() || drawerOpen()) return;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      exitEl.hidden = false;
      document.body.classList.add('cc-exit-open');
      clearTimeout(idleTimer);
    };
    const hide = () => {
      exitEl.hidden = true;
      document.body.classList.remove('cc-exit-open');
    };
    exitEl.querySelectorAll('[data-cc-exit-close]').forEach((b) => b.addEventListener('click', hide));
    exitEl.querySelector('[data-cc-exit-buy]')?.addEventListener('click', () => {
      hide();
      const form = document.querySelector('cc-product-form form');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        form.requestSubmit();
      }
    });
    let idleTimer;
    const armIdle = () => {
      clearTimeout(idleTimer);
      if (!seen()) idleTimer = setTimeout(show, idleMs);
    };
    let lastY = window.scrollY;
    let lastT = Date.now();
    let deepest = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const now = Date.now();
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      deepest = Math.max(deepest, docH ? y / docH : 0);
      const dy = lastY - y;
      const dt = now - lastT;
      if (deepest > 0.35 && dy > 160 && dt < 420 && y < docH * 0.5) show();
      lastY = y;
      lastT = now;
      armIdle();
    }, { passive: true });
    ['touchstart', 'click', 'keydown'].forEach((ev) => document.addEventListener(ev, armIdle, { passive: true }));
    window.addEventListener('pagehide', () => clearTimeout(idleTimer));
    armIdle();
  }

  /* Gallery dots / thumbs */
  document.querySelectorAll('[data-cc-gallery]').forEach((g) => {
    const track = g.querySelector('.cc-gallery__track');
    const slides = [...g.querySelectorAll('.cc-gallery__slide')];
    const dots = [...g.querySelectorAll('.cc-gallery__dots button')];
    const thumbs = [...g.querySelectorAll('.cc-gallery__thumbs button')];
    if (!track || slides.length < 2) return;
    const setCurrent = (idx) => {
      dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === idx ? 'true' : 'false'));
    };
    const goTo = (idx) => track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((en) => en.isIntersecting && setCurrent(slides.indexOf(en.target))),
        { root: track, threshold: 0.6 }
      );
      slides.forEach((s) => io.observe(s));
    }
  });

  /* Collection sort */
  document.querySelectorAll('[data-cc-sort]').forEach((sel) =>
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    })
  );
})();
